import React, { useState, useEffect, useContext } from 'react';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import { API } from '../../../../API/API';
import { UserContext } from '../../../../context/UserContext';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import FieldText from '../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../const/MessageConst';
import { Row, Col } from 'antd';
import FieldNumberFormat from '../../../../components/FieldNumberFormat/FieldNumberFormat';
import { constData } from '../../../../const/Const';
import FieldTextArea from '../../../../components/FieldTextArea/FieldTextArea';
import FieldItemList from '../../../../components/FieldItemList/FieldItemList';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import ButtonDefaultWithLoad from '../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';

const EmpEmplHistNewSH = (props) => {

    const { userInfo } = useContext(UserContext);

    const [initialData, setInitialData] = useState({
        "employmenttype": "SH",
        "historyid": -1,
        "depid": null,
        "positionid": null,
        "begindate": null,
        "enddate": null,
        "basewagecurrcode": "MNT",
        "basewage": 0,
        "insuretypeid": null,
        "labourcondition": "N",
        "ismult": null,
        "multyear": 0,
        "note": null,
        "empid": props.empid,
        "companyid": userInfo.companyid ? userInfo.companyid.toString().toUpperCase() : "",
        "isgovcompany": false,
        "companyname": userInfo.companyname ? userInfo.companyname : "",
        "shifttype": null,
        "emptype": props.emptype
    });

    const [data, setData] = useState({ ...initialData });
    const [dShiftType] = useState(constData.Gov_shift_Type);
    const [dLabourCondition] = useState(constData.hrContract_LabourCondition);

    const [checkRule, setCheckRule] = useState(false);
    const [colSpan, setColSpan] = useState(window.innerWidth > 800 ? 12 : 24);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getExistsData = async () => {
        let tData = { ...initialData };

        if (props.shifttype) {
            tData.shifttype = props.shifttype;
        }

        if (props.historyid > 0) {
            setLoading(true);
            await API.get('/api/humanresource/employment/get_empemplhist?historyid=' + props.historyid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });

            setLoading(false);
        } else {
            if (props.shifttype) {
                tData.shifttype = props.shifttype;
            }
            if (props.shifttype == 'SL') {
                await API.get('/api/humanresource/Employment/get_empemplhist_for_date?companyid=' + userInfo.companyid + '&empid=' + props.empid).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        if (response.data.retdata?.length > 0) {
                            tData = { ...tData, ...response.data.retdata[0] };
                        }
                    }
                });
            }
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.historyid])

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'depid') {
                tData.positionid = null;
            }

            setData(tData);
        }
    }

    const onSave = async () => {
        let vRule = true;
        setCheckRule(true);
        let tData = { ...data };

        if (vRule) {
            setLoadingSave(true);

            tData.empid = props.empid;
            tData.emptype = props.emptype;
            await API.post('/api/humanresource/employment/save_empemplhist', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
            setLoadingSave(false);
        }
    }

    const onDismiss = () => {
        setData({ ...initialData });
        setCheckRule(false);
        props.onDismiss();
    }

    const onDelete = async () => {
        await API.post('/api/humanresource/employment/delete_empemplhist?historyid=' + props.historyid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
                onDismiss();
            }
        });
    }

    let compSave = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <ButtonDefaultWithLoad disable={props.disable} loading={loadingSave} onClick={onSave} text="Хадгалах" />
        </div>
    );

    return (
        <PanelBase
            headerText={props.historyid > 0 ? 'Дотоод хөдөлгөөний түүх засах' : 'Дотоод хөдөлгөөний түүх нэмэх'}
            isOpen={props.onOpen}
            onDismiss={onDismiss}
            PanelType='large'
            delete={!props.disable}
            onDelete={onDelete}
            buttons={compSave}
        >
            <div style={{ marginTop: 25 }}>
                <div>
                    <Row gutter={[16, 16]}>
                        <Col span={colSpan}>
                            <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Дотоод хөдөлгөөний төрөл" data={dShiftType} keyfield='shifttype' defaultValue={data.shifttype} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldText loading={loading} disable={true} onChanged={fieldOnChanged} title="Хуулийн этгээд" keyfield='companyname' defaultValue={data.companyname} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldItemList loading={loading} required onChanged={fieldOnChanged} title="Даатгуулагчийн төрөл" keyfield='insuretypeid' keyfieldname='insuretypename' defaultValue={[{ key: data.insuretypeid, name: data.insuretypename }]} checkreq={checkRule} dataurl="/api/humanresource/organization/get_insure_type_dropdown" />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldItemList loading={loading} required onChanged={fieldOnChanged} title="Дотоод нэгж" keyfield='depid' keyfieldname='depname' defaultValue={[{ key: data.depid, name: data.depname }]} dataurl='/api/humanresource/organization/get_department_dropdown' dataparam={[{ key: 'companyid', name: userInfo.companyid }]} checkreq={checkRule} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldItemList loading={loading} disable={data.depid ? false : true} required onChanged={fieldOnChanged} title="Ажлын байр" keyfield='positionid' keyfieldname='positionname' defaultValue={[{ key: data.positionid, name: data.positionname }]} dataurl="/api/humanresource/organization/get_position_dropdown" dataparam={[{ key: 'depid', name: data.depid }]} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Эхэлсэн огноо" keyfield='begindate' defaultValue={data.begindate} checkreq={checkRule} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldDate loading={loading} onChanged={fieldOnChanged} title="Дууссан огноо" keyfield='enddate' defaultValue={data.enddate} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <Row gutter={[16, 16]}>
                                <Col span={20}>
                                    <FieldNumberFormat loading={loading} required onChanged={fieldOnChanged} title="Үндсэн цалин" keyfield='basewage' defaultValue={data.basewage} checkreq={checkRule} />
                                </Col>
                                <Col span={4}>
                                    <FieldText loading={loading} disable={true} title="Валют" keyfield='basewagecurrcode' defaultValue={data.basewagecurrcode} />
                                </Col>
                            </Row>
                        </Col>
                        <Col span={colSpan}>
                            <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Хөдөлмөрийн нөхцөл" data={dLabourCondition} keyfield='labourcondition' defaultValue={data.labourcondition} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={24}>
                            <FieldTextArea loading={loading} onChanged={fieldOnChanged} title="Нэмэлт мэдээлэл" keyfield='note' defaultValue={data.note} />
                        </Col>
                    </Row>
                </div>
            </div>
        </PanelBase >
    );
}

export default EmpEmplHistNewSH;